import { Title } from "@solidjs/meta";
import { Show } from "solid-js";
import { ButtonA } from "~/common/button";
import twelveLogoWithText from "@assets/images/twelve-logo-with-text.svg?url";

type Props = {
  isTwelveAdmin: boolean;
};

export default function Welcome(props: Props) {
  return (
    <>
      <Title>Welcome to Twelve</Title>

      <div class="flex min-h-dvh items-center justify-center px-4">
        <div class="w-full max-w-md space-y-6 rounded-2xl bg-white p-8 text-center shadow-sm">
          <img src={twelveLogoWithText} alt="Twelve logo" class="mx-auto h-10" />

          <p class="text-typography-primary">
            Looks like you don't have access to any locations. Please reach out to support to get
            you set up.
          </p>

          <Show when={props.isTwelveAdmin}>
            <ButtonA variant="primary" href="/internal" width="full">
              Take me to Twelve Admin
            </ButtonA>
          </Show>
        </div>
      </div>
    </>
  );
}
